<template>
  <div>
    <v-carousel
      hide-delimiter-background
      hide-delimiters
      cycle
      :height="$vuetify.breakpoint.xsOnly ? 200 : $vuetify.breakpoint.smOnly ? 320 : 600"
      :show-arrows="false"
      interval="4000"
    >
      <v-carousel-item v-for="(banner, index) in banners" :key="index">
        <v-img :src="banner.src" :alt="banner.alt" class="marketplace-banner-image" cover />
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "MarketplaceBanner",
  data() {
    return {
      banners: [
        { src: "/cover/34830.jpg", alt: "Marketplace Banner" },
      ],
    };
  },
};
</script>

<style scoped>
.marketplace-banner-image {
  width: 100%;
  height: 100%;
}

.marketplace-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
  padding-top: 100px;
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .marketplace-section {
    max-width: 1200px;
  }
}

.marketplace-h1 {
  font-size: 40px;
  font-weight: 600;
}

.marketplace-h3 {
  font-size: 28px;
}

.marketplace-text {
  font-size: 16px;
}

@media (max-width: 768px) {
  .marketplace-h1 {
    font-size: 18px;
  }

  .marketplace-h3 {
    font-size: 13px;
  }
}
</style>
